import { ReactElement } from 'react';

import { IFragmentCta, IFragmentFaqGrouping } from 'types/contentful';
import FaqQuestionAnswer from './FaqQuestionAnswer';
import CTA from '../Cta';

interface FaqSingleGroupingProps {
  heading?: string;
  cta?: IFragmentCta;
  faqGroupings: IFragmentFaqGrouping[];
}

export default function FaqSingleGrouping({
  heading,
  faqGroupings,
  cta,
}: FaqSingleGroupingProps): ReactElement {
  const allFaqs = faqGroupings[0].fields.faqs.map(({ fields: { question, answer } }, index) => {
    return (
      <div className="py-1" key={index}>
        <FaqQuestionAnswer question={question} answer={answer} />
      </div>
    );
  });

  return (
    <div className="text-black px-site-component ecp-mt pb-10 md:pb-20 ">
      <h2 className="md:pb-4 pb:2 font-heading text-new-34 lg:text-4xl lg:leading-new-43">
        {heading}
      </h2>
      <div>{allFaqs}</div>
      {cta && (
        <div className="md:pb-20 pb-12 md:pt-0 pt-6">
          <CTA {...cta.fields} />
        </div>
      )}
    </div>
  );
}
